function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, useCallback, useEffect, useRef, useState } from "react";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { cnm } from "../utils";
import { NextButton, PrevButton } from "./CarouselButtons";
export function Carousel(param) {
    var instanceRef = param.instanceRef, children = param.children, options = param.options, _autoplay = param.autoplay, className = param.className, classNames = param.classNames, onSelect = param.onSelect;
    var ref = useRef(Autoplay(_objectSpread({
        stopOnInteraction: false,
        stopOnMouseEnter: true,
        playOnInit: false
    }, _autoplay))), autoplay = ref.current;
    var ref1 = _slicedToArray(useEmblaCarousel(_objectSpread({
        align: "start",
        containScroll: "trimSnaps",
        skipSnaps: true
    }, options), [
        autoplay
    ]), 2), viewportRef = ref1[0], embla = ref1[1];
    var ref2 = useState(false), prevBtnEnabled = ref2[0], setPrevBtnEnabled = ref2[1];
    var ref3 = useState(false), nextBtnEnabled = ref3[0], setNextBtnEnabled = ref3[1];
    var scrollPrev = useCallback(function() {
        return embla === null || embla === void 0 ? void 0 : embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = useCallback(function() {
        return embla === null || embla === void 0 ? void 0 : embla.scrollNext();
    }, [
        embla
    ]);
    useEffect(function() {
        if (!embla) return;
        if (instanceRef) {
            // eslint-disable-next-line no-param-reassign
            instanceRef.current = embla;
        }
        embla.on("init", function() {
            setPrevBtnEnabled(embla.canScrollPrev());
            setNextBtnEnabled(embla.canScrollNext());
        });
        embla.on("select", function() {
            setPrevBtnEnabled(embla.canScrollPrev());
            setNextBtnEnabled(embla.canScrollNext());
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(embla);
        });
        embla.on("resize", function() {
            setPrevBtnEnabled(embla.canScrollPrev());
            setNextBtnEnabled(embla.canScrollNext());
        });
    }, [
        embla,
        instanceRef,
        onSelect
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: cnm("relative", className, classNames === null || classNames === void 0 ? void 0 : classNames.carousel),
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: viewportRef,
                className: cnm("overflow-hidden", classNames === null || classNames === void 0 ? void 0 : classNames.viewport),
                children: /*#__PURE__*/ _jsx("div", {
                    className: cnm("flex h-full", classNames === null || classNames === void 0 ? void 0 : classNames.container),
                    style: {
                        marginLeft: "calc(-1 * var(--space-between))"
                    },
                    children: Children.map(children, function(child) {
                        /*#__PURE__*/ return _jsx("div", {
                            className: classNames === null || classNames === void 0 ? void 0 : classNames.slide,
                            style: {
                                minWidth: "calc(100% / var(--slides-per-view, 1))",
                                maxWidth: "calc(100% / var(--slides-per-view, 1))",
                                paddingLeft: "var(--space-between)"
                            },
                            children: child
                        });
                    })
                })
            }),
            /*#__PURE__*/ _jsx(PrevButton, {
                disabled: !prevBtnEnabled,
                className: cnm(classNames === null || classNames === void 0 ? void 0 : classNames.buttons, classNames === null || classNames === void 0 ? void 0 : classNames.prevButton),
                onClick: scrollPrev
            }),
            /*#__PURE__*/ _jsx(NextButton, {
                disabled: !nextBtnEnabled,
                className: cnm(classNames === null || classNames === void 0 ? void 0 : classNames.buttons, classNames === null || classNames === void 0 ? void 0 : classNames.nextButton),
                onClick: scrollNext
            })
        ]
    });
}
